export default __webpack_public_path__ + "static/media/documentSVG.b06c46dd.svg";